import Vue from 'vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import Gravatar from 'vue-gravatar'
import firebase from 'firebase'
import App from './App.vue'
import "firebase/performance"

Vue.use(BootstrapVue)
Vue.component('v-gravatar', Gravatar)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

/* for fontawesome */
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import InstantSearch from 'vue-instantsearch'

library.add(fas, far)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(InstantSearch)
/* end */

/* for firebase */

const firebaseConfig = {
	apiKey: "AIzaSyD-CQn4chUUxHWD4qutlgkoGyfueo6nTpc",
	authDomain: "logcrow.firebaseapp.com",
	databaseURL: "https://logcrow.firebaseio.com",
	projectId: "logcrow",
	storageBucket: "logcrow.appspot.com",
	messagingSenderId: "38489355712",
	appId: "1:38489355712:web:a447ec06404102b8d98425",
	measurementId: "G-3B0QDM0NZ1"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
Vue.config.productionTip = false
firebase.performance();

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
